import React from 'react';

interface CurrentUser {
  id: number;
  name: string;
  isSignedin: boolean;
  signin: (user: string) => void;
  signout: () => void;
}

const CurrentUserContext = React.createContext<CurrentUser | null>(null!);

function CurrentUserProvider({ children }: { children: React.ReactNode }) {
  const [currentUser, setCurrentUser] = React.useState<any>(null);

  const signin = async (newUser: string) => {
    setCurrentUser({ ...currentUser, data: newUser });
  };

  const signout = () => {
    setCurrentUser(null);
  };

  return (
    <CurrentUserContext.Provider
      value={{ ...currentUser, isSignedin: !!currentUser, signin, signout }}
    >
      {children}
    </CurrentUserContext.Provider>
  );
}

function useCurrentUser() {
  return React.useContext(CurrentUserContext);
}

export default CurrentUserContext;
export { CurrentUserProvider, useCurrentUser };
